// Time helpers. Everything stores as Unix seconds (UTC).
// Display logic lives in the web app and uses date-fns-tz.

export const nowSec = (): number => Math.floor(Date.now() / 1000);

export const secsToMs = (s: number): number => s * 1000;
export const msToSecs = (ms: number): number => Math.floor(ms / 1000);

export const fmtClock = (secs: number): string => {
  const h = Math.floor(secs / 3600);
  const m = Math.floor((secs % 3600) / 60);
  const s = secs % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
};

export const fmtDur = (mins: number): string => {
  if (mins < 60) return `${mins}m`;
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  return m ? `${h}h ${m}m` : `${h}h`;
};
